import { colors } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import Section from './components/Section'

interface RegularHoursProps {
  regularMinues: number
}

const RegularHours = ({ regularMinues }: RegularHoursProps) => {
  return (
    <Section
      title={i18n.t('clock_in.sidepanel.accordion.regular_hours.title')}
      minutes={regularMinues}
      circleColor={colors.viridian1000}
    />
  )
}

export default RegularHours
